import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../services/user.service';
import { CONTENT } from './util/content';
import { Constants, SsoApplicationType } from '../../shared/constants/constants';
import { Roles } from 'src/app/shared/constants/roles';


@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

	@Input() isDefaultHeaderMode = false;
	content = CONTENT;
	ROLES = Roles;

	constructor(
		public user: UserService,
		private router: Router
	) { }

	goToHome() {
		this.router.navigate(['/home']);
	}

	redirectBenefitLookup(){
		this.router.navigate(['/benefits/benefit-lookup']);
	}

	memberPaymentResearchSso() {
		const url = this.router.serializeUrl(
			this.router.createUrlTree([Constants.SSO_REDIRECTION_FULL_PATH], {
				queryParams: {
					sso: SsoApplicationType.MEMBER_PAYMENT_RESEARCH
				}
			})
		);
		window.open(url, SsoApplicationType.MEMBER_PAYMENT_RESEARCH);
	}

	goToProfile() {
		this.router.navigate(['/my-profile']);
	}

	logOff() {
		this.user.logoutUser();
		this.router.navigate(['login']);
	}
}
